import * as React from 'react'

import { cn } from '@/lib/utils'
import { SelectTrigger } from '@/components/ui/select'

/**
 * GodUI Magic Input's rainbow treatment, adapted to the site's existing
 * shadcn primitives. The visual layers live outside the native control so
 * browser validation, autofill, and form-library refs keep working normally.
 */
const MagicLayers = () => (
  <>
    <span className="magic-input__shadow" aria-hidden="true" />
    <span className="magic-input__edge" aria-hidden="true" />
  </>
)

const MagicInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, ...props }, ref) => (
    <div className={cn('magic-input', className)}>
      <MagicLayers />
      <input ref={ref} className="magic-input__control" {...props} />
    </div>
  )
)
MagicInput.displayName = 'MagicInput'

const MagicTextarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => (
    <div className={cn('magic-input magic-input--textarea', className)}>
      <MagicLayers />
      <textarea ref={ref} className="magic-input__control" {...props} />
    </div>
  )
)
MagicTextarea.displayName = 'MagicTextarea'

function MagicSelectTrigger({ className, ...props }: React.ComponentProps<typeof SelectTrigger>) {
  return (
    <div className={cn('magic-choice', className)}>
      <SelectTrigger {...props} className="magic-choice__control" />
    </div>
  )
}

export { MagicInput, MagicTextarea, MagicSelectTrigger }
